import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-group",
  templateUrl: "./group.component.html",
  styleUrls: ["./group.component.scss"],
})
export class GroupComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
